import { Injectable } from '@angular/core';
import { PageHeaderNavItem } from '../../../../../shared/components/page-header-nav/models/page-header-nav-item';
import { ButtonMenuOption } from '../../../../../shared/components/button-menu/models/button-menu-option';

@Injectable({
    providedIn: 'root',
})
export class StepNavigationButtonService {
    public createPrimaryLink(
        title: string,
        action?: () => void,
        buttonMenuOptions?: ButtonMenuOption[],
        disabled?: boolean,
    ): PageHeaderNavItem {
        return this.createLink(
            title,
            '!rounded-full',
            action,
            buttonMenuOptions,
            undefined,
            disabled,
        );
    }

    public createSecondaryLink(
        title: string,
        action?: () => void,
        buttonMenuOptions?: ButtonMenuOption[],
    ): PageHeaderNavItem {
        return this.createLink(
            title,
            '!rounded-lg !bg-secondary-500 !text-tertiary-50',
            action,
            buttonMenuOptions,
        );
    }

    public createTertiaryLink(
        title: string,
        action?: () => void,
        buttonMenuOptions?: ButtonMenuOption[],
    ): PageHeaderNavItem {
        return this.createLink(
            title,
            '!rounded-lg !bg-tertiary-700 !text-tertiary-50',
            action,
            buttonMenuOptions,
        );
    }

    /**
     * Used when needing a navigation button with unique CSS, outside the defined primary, secondary, and tertiary styles
     * @param title Button text
     * @param classList CSS styling
     * @param action Navigation function
     * @param imageUrl Optional image URL
     * @returns
     */
    public createCustomCssLink(
        title: string,
        classList: string,
        action?: () => void,
        imageUrl?: string,
    ): PageHeaderNavItem {
        return this.createLink(title, classList, action, undefined, imageUrl);
    }

    private createLink(
        title: string,
        classList: string,
        action?: () => void,
        buttonMenuOptions?: ButtonMenuOption[],
        imageUrl?: string,
        disabled?: boolean,
    ): PageHeaderNavItem {
        return {
            title,
            classList,
            action: action?.bind(this),
            imageUrl,
            buttonMenuOptions,
            disabled: disabled,
        };
    }
}
